import { render, staticRenderFns } from "./lawyerMy.vue?vue&type=template&id=937790e4&scoped=true"
import script from "./lawyerMy.vue?vue&type=script&lang=js"
export * from "./lawyerMy.vue?vue&type=script&lang=js"
import style0 from "./lawyerMy.vue?vue&type=style&index=0&id=937790e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937790e4",
  null
  
)

export default component.exports